import React, { useEffect } from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const MarketAnalysis = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--service-bg-image',
      "url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop')"
    );
    return () => {
      document.documentElement.style.removeProperty('--service-bg-image');
    };
  }, []);
  const benefits = [
    {
      title: 'Informed Decisions',
      description: 'Make strategic business decisions based on comprehensive market intelligence and data-driven insights.'
    },
    {
      title: 'Competitive Advantage',
      description: 'Stay ahead of competitors by understanding market trends, opportunities, and threats.'
    },
    {
      title: 'Risk Reduction',
      description: 'Minimize business risks by identifying market challenges and potential obstacles early.'
    },
    {
      title: 'Growth Opportunities',
      description: 'Discover untapped market opportunities and develop strategies to capitalize on them effectively.'
    }
  ];

  const features = [
    'Comprehensive market research and analysis',
    'Competitive landscape assessment',
    'Industry trend identification and forecasting',
    'Customer segmentation and behavior analysis',
    'Market sizing and opportunity assessment',
    'SWOT analysis and strategic positioning',
    'Market entry and expansion analysis',
    'Pricing strategy research',
    'Consumer insights and preference studies',
    'Market performance monitoring and reporting'
  ];

  const process = [
    {
      title: 'Research Design',
      description: 'Define research objectives, methodologies, and data sources to ensure comprehensive market understanding.'
    },
    {
      title: 'Data Collection',
      description: 'Gather market data from multiple sources including primary research, industry reports, and competitive intelligence.'
    },
    {
      title: 'Analysis',
      description: 'Analyze collected data to identify patterns, trends, opportunities, and threats in the market landscape.'
    },
    {
      title: 'Insights Development',
      description: 'Transform data into actionable insights and strategic recommendations for your business.'
    },
    {
      title: 'Reporting & Strategy',
      description: 'Deliver comprehensive reports with clear recommendations and support strategy development based on findings.'
    }
  ];

  return (
    <ServiceTemplate
      icon="📈"
      title="Market Analysis"
      subtitle="In-depth market research and analysis to identify opportunities and stay ahead of industry trends"
      description="Our market analysis services provide deep insights into your industry, competitors, and customers. Through comprehensive research and data analysis, we help you understand market dynamics, identify opportunities, and develop strategies that position your business for success in an ever-changing marketplace."
      benefits={benefits}
      features={features}
      process={process}
      callToAction="Ready to gain deeper market insights and competitive advantage? Contact us to learn how our market analysis services can guide your strategic decisions."
    />
  );
};

export default MarketAnalysis;

